var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 864.26 864.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fb7044;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 432.13,
    cy: 432.13,
    r: 432.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M592.74,368.72V497.45a77.13,77.13,0,0,1-77.13,77.13H440.16L401.54,641.5l-38.63-66.92H287.46a77.13,77.13,0,0,1-77.13-77.13V368.72a77.13,77.13,0,0,1,77.13-77.13H515.61A77.13,77.13,0,0,1,592.74,368.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M653.93,299.89V428.61a77,77,0,0,1-41.61,68.45,77.22,77.22,0,0,0,3.37-22.56V345.78a77.13,77.13,0,0,0-77.13-77.13H310.41a76.55,76.55,0,0,0-35.53,8.68,77.14,77.14,0,0,1,73.77-54.57H576.8A77.13,77.13,0,0,1,653.93,299.89Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset4);
export default __webpack_public_path__ + "static/media/Asset 4.13e910839a41ed74949914f850b0e8da.svg";
export { ForwardRef as ReactComponent };